import { render, staticRenderFns } from "./TopicReply.vue?vue&type=template&id=50e0660e&scoped=true&"
import script from "./TopicReply.vue?vue&type=script&lang=js&"
export * from "./TopicReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0660e",
  null
  
)

export default component.exports